module.exports = __webpack_public_path__ + "static/media/400129_01.b7b0d32e.png";